import React, { memo } from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { ValueStub } from 'constants/data';
import { BrokerConditionStatusEnum } from 'constants/loanActionEditor';

import { BROKER_STATUS_DISPLAY } from './BrokerStatusCell.constants';

const BrokerStatusCell = ({ status }) => {
  const display = status ? BROKER_STATUS_DISPLAY[status] : null;

  if (!display) {
    return ValueStub.ALTERNATE;
  }

  return <LabelCDS shrinkable size={LabelSize.S} title={display.label} variant={display.variant} />;
};

BrokerStatusCell.propTypes = {
  status: PropTypes.oneOf(Object.values(BrokerConditionStatusEnum)),
};

export default memo(BrokerStatusCell);
